import { forwardRef } from 'react'
import Styles from './RadioButton.module.scss'
import cx from 'classnames'
import { useButton } from '@react-aria/button'
import { useObjectRef } from 'utils/useObjectRef'
import { useHover } from '@react-aria/interactions'
import { RadioButtonProps } from './Types'

const RadioButton = forwardRef<HTMLDivElement, RadioButtonProps<string>>((props, fRef) => {
  const ref = useObjectRef(fRef)
  const { buttonProps } = useButton(props, ref)
  const { hoverProps, isHovered } = useHover({})
  const { selected, option, showBullet = true, classOverrides, isDisabled = false, variant = '' } = props

  const isSelectedClassName = classOverrides?.selected || Styles.selected
  const isHoveredClassName = classOverrides?.hovered || Styles.hovered
  const isDisabledClassName = classOverrides?.disabled || Styles.disabled
  const titleClassName = classOverrides?.title || Styles.title
  const descriptionClassName = classOverrides?.description || Styles.description
  const buttonStyle = classOverrides?.button || Styles.root
  const bulletStyle = classOverrides?.bullet || Styles.bullet

  return (
    <div
      className={cx(buttonStyle, Styles[variant], {
        [isSelectedClassName]: selected,
        [isHoveredClassName]: isHovered,
        [isDisabledClassName]: isDisabled,
      })}
      {...buttonProps}
      {...hoverProps}
      aria-selected={selected}
      data-testid="radioButton"
      data-heap-id={`radio-button-${option.key}`}
    >
      {showBullet && <div className={bulletStyle} />}
      <div>
        {option.title && <div className={titleClassName}>{option.title}</div>}
        {option.description && <div className={descriptionClassName}>{option.description}</div>}
      </div>
    </div>
  )
})

export { RadioButton }
